import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const StoreAdminReviewPage = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Reviews</h5>
                      </div>
                    </div>
                  </div>
                  <div className="container">
                    <br />
                    <div className="reviews">
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead className="thead-light">
                            <tr>
                              <th>Id</th>
                              <th>From</th>
                              <th>On</th>
                              <th>Rating</th>
                              <th>Comment</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>122</td>
                              <td>Order by Abde Faisal</td>
                              <td>2/1/2025</td>
                              <td>4/5</td>
                              <td>Rice was good and quick service</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreAdminReviewPage;
